<template>
  <div v-if="artists.length > 0" class="filter-wrapper">
    <div
      v-for="artist in topSellers"
      v-bind:key="'artist-filter-' + artist.handle"
      class="filter-button"
      @click="onClick(artist.handle)"
    >
      <div class="button-content">
        <img :src="artist.profile_image" class="artist-avatar rounded-circle" />
        <div class="artist-handle">@{{artist.handle}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "top-sellers-filter",
  props: {
    artists: {
      type: Array,
      default: () => [],
      description: "Array of top sellers"
    },
    onClick: {
      type: Function,
      description: "Callback function for button click"
    }
  },
  computed: {
    ...mapState(["topSellers"])
  }
};
</script>

<style scoped lang="scss">
.filter-wrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 1.5rem 1rem 0 1rem;
  background-color: #f7f7f7;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;

  .filter-button {
    width: 20%;
    display: flex;

    justify-content: center;
    align-items: center;
    margin-bottom: 1.5rem;

    .button-content {
      display: flex;
      flex-direction: column;
      align-self: center;
      align-items: center;
      cursor: pointer;
      flex-direction: column;
      width: auto;
      img {
        width: 100px;
        margin-bottom: 0.5rem;
      }

      .artist-handle {
        color: #333;
        font-weight: bold;
        font-size: 0.925rem;
      }
    }
  }
}

@media (max-width: 991.98px) {
  .filter-wrapper {
    .filter-button {
      width: 33%;
    }
  }
}

@media (max-width: 575.98px) {
  .filter-wrapper {
    .filter-button {
      width: 50%;
    }
  }
}
</style>
